import Vue from 'vue';
import VueMobileDetection from "vue-mobile-detection";

Vue.use(VueMobileDetection);